import { Text } from '@livechat/design-system-react-components'
import NotInstallableButton from './NotInstallableButton'

export const ResellerLicense = (props) => {
  return (
    <NotInstallableButton {...props}>
      <Text as="span">
        Please, contact your subscription partner and request for this app to be
        purchased.
      </Text>
    </NotInstallableButton>
  )
}
